/* eslint-disable jsx-a11y/anchor-is-valid, no-script-url */
import React from 'react';
import PropTypes from 'prop-types';
import { HelpIcon } from './help-icon';

export class FeedSyntaxView extends React.PureComponent {
  static defaultProps = {
    selectedFeed: false,
    selectedAttribute: false,
  };

  render() {
    const {
      i18n, selectedFeed, selectedAttribute,
    } = this.props;
    const renderPart = (text, isBold) => (
      isBold ? <span><b>{text}</b></span> : <span>{text}</span>
    );

    return (
      <div className="panel-heading margin-zero u-full-width display-inline-block">
        <div className="feed-and-attribute-selector-syntax-container">
          <span className="feed-and-attribute-selector-syntax">
            {renderPart(i18n.getString('AdCustomizer_Syntax_Syntax'), false)}
            {renderPart(': {=', false)}
            {renderPart(i18n.getString('AdCustomizer_Syntax_FeedName'), !selectedFeed)}
            {renderPart('.', false)}
            {renderPart(
          i18n.getString('AdCustomizer_Syntax_AttributeName'),
          selectedFeed && !selectedAttribute
        )}
            {renderPart(':', false)}
            {renderPart(
              i18n.getString('DefaultText_Label'),
              selectedFeed && selectedAttribute
            )}
            {renderPart('}', false)}
          </span>
          <HelpIcon
            topic="pop_BA_NewAdCreate_AdCustomizer_Syntax"
            ariaLabel={i18n.getString('Click to learn more about {{item}}', { item: this.conditionTypeLabel })}
          />
        </div>
      </div>);
  }
}

FeedSyntaxView.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  selectedFeed: PropTypes.bool,
  selectedAttribute: PropTypes.bool,
};
